"use client";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Image from "next/image";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";

import comCSS from "./HIWStep.module.scss";
import ResponsiveImage from "@/next-src/components/ui/responsive-image/ResponsiveImage";

const HIWStep = ({ data, className = "" }) => {
  const [isShown, setIsShown] = useState(null);
  const wrapperRef = useRef();

  // this is to show percent data animation. The code sets it only once, when a user scrolled to the section
  useEffect(() => {
    if (typeof window !== "undefined") {
      const onScroll = () => {
        if (!wrapperRef?.current) return;

        const isInView =
          wrapperRef.current.getBoundingClientRect().top <=
          (window.innerHeight / 3) * 2;
        if (isInView) {
          setIsShown(true);
        }
      };

      window.addEventListener("scroll", onScroll, false);
      window.addEventListener("resize", onScroll, false);

      // Call handler right away so state gets updated with initial window size
      onScroll();

      return () => {
        window.removeEventListener("scroll", onScroll, false);
        window.removeEventListener("resize", onScroll, false);
      };
    }
  }, []);

  const {
    id,
    stepNumber,
    title,
    titleMobile,
    description,
    descriptionMobile,
    checklist,
    checklistMobile,
    images,
    additionalInfo,
    stepsCount,
  } = data;
  return (
    <>
      <div
        data-w-id={id}
        className={cn(
          "timeline-step-wrap",
          `_${stepNumber}`,
          className,
          comCSS.wrapper,
          { [comCSS.active]: isShown }
        )}
        ref={wrapperRef}
      >
        <div className="margin-bottom margin-xxsmall">
          <div className="timeline-step-text">
            {stepNumber}{" "}
            <span className="timeline-text-span">/&nbsp;0{stepsCount}</span>
          </div>
        </div>
        <div className="margin-bottom margin-small">
          <h4 className={comCSS.heading}>
            <span className="step-number-span">{stepNumber} •&nbsp;</span>
            <span className="hide-tablet">{convertHTMLtoJSX(title)}</span>
            <span className="hide-desktop">
              {convertHTMLtoJSX(titleMobile)}
            </span>
          </h4>
        </div>
        <div className="margin-bottom margin-small hide-tablet">
          {convertHTMLtoJSX(description)}
        </div>
        <div className="margin-bottom margin-small hide-desktop">
          {convertHTMLtoJSX(descriptionMobile)}
        </div>
        <div className={cn("vertical-list-wrap hide-tablet", comCSS.checklist)}>
          {convertHTMLtoJSX(checklist)}
        </div>
        <div
          className={cn("vertical-list-wrap hide-desktop", comCSS.checklist)}
        >
          {convertHTMLtoJSX(checklistMobile)}
        </div>
        {additionalInfo && (
          <div className="margin-top margin-small">
            {convertHTMLtoJSX(additionalInfo)}
          </div>
        )}
      </div>
      <div className="timeline-pictures-inner show-from-tablet">
        {images.map((el) => (
          <div
            key={el.id}
            className={cn("timeline-picture-mask", el.orientation)}
          >
            <ResponsiveImage
              width={256}
              height={352}
              src={el.src}
              lazyLoading
              sizes="(max-width: 479px) 100vw, (max-width: 991px) 35vw, 100vw"
              alt={el.alt}
              className="cover-image"
            />
          </div>
        ))}
      </div>
    </>
  );
};

HIWStep.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({}),
};

export default HIWStep;
